import React, { useState } from 'react';
import Modal from './components/Modal';
import Table from './components/Table';
import Button from './components/Button';
import './App.css';

function App() {
  const [data, setData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  function handleAddData(formData) {
    const newData = {
      id: data.length + 1,
      name: formData.name,
      prelim: formData.prelim,
      midterm: formData.midterm,
      final: formData.final
    };
    setData([...data, newData]);
    setIsModalOpen(false);
  }

  function handleOpen() {
    setIsModalOpen(true);
  }

  function handleClose() {
    setIsModalOpen(false);
  }

  return (
    <div className="app-bg">
      <Button onClick={handleOpen} />
        {isModalOpen && <Modal onAddData={handleAddData} onClose={handleClose} />}
      <Table data={data} />
    </div>
  );
}

export default App;